import { api } from 'services';

const costCenterService = {
  getAll: async () => {
    return await api.get('cost-center');
  }
};

export default costCenterService;
